export default __webpack_public_path__ + "static/media/smartlitepro.1b648f50.png";